import { roundToNearestEven } from 'src/domains/calculators/utilities/round';
import { Resolution } from 'src/domains/calculators/utilities/types';

export function getFramingDecisionResolution({
  containerResolution,
  protection,
}: {
  containerResolution: Resolution;
  protection: number;
}): Resolution {
  const normalizedSafetyCrop = 1 - protection;

  const framingDecisionWidth = containerResolution.width * normalizedSafetyCrop;
  const framingDecisionHeight =
    containerResolution.height * normalizedSafetyCrop;

  return {
    width: roundToNearestEven(framingDecisionWidth),
    height: roundToNearestEven(framingDecisionHeight),
  };
}
